<template>
  <div>
    <div id="login" :class="this.$vuetify.theme.dark ? 'loginDark' : 'login'"></div>
    <v-app id="logg" style="background-color:transparent;">
      <v-container fluid style="height: 100%;">
        <v-row justify="space-around">
          <v-col
            lg="4"
            md="4"
            sm="4"
            style="padding-top: 0 !important;  padding-bottom: 0px;display: contents;"
          >
            <img
              v-if="!this.$vuetify.theme.dark"
              src="../assets/bti.png"
              alt="BosonTI"
              :style="styleLogo"
            />
            <img
              v-if="this.$vuetify.theme.dark"
              src="../assets/bti-dark.png"
              alt="BosonTI"
              :style="styleLogo"
            />
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-col lg="10" md="10" sm="10">
            <v-row justify="space-around" class="paddingLoginCard">
              <v-card class="cardLogin" :style="styleMargin">
                <v-card-title primary-title style="text-align: center; padding-bottom: 0;">
                  <div style="width: 100%;">
                    <h3
                      class="headline mb-0"
                      style="cursor: context-menu;font-size: 30px !important;"
                    >{{ $t("login") }}</h3>
                  </div>
                  <v-col lg="12" sm="12" md="12" style="margin-top: 15px;">
                    <v-progress-linear
                      height="2"
                      :color="colorTheme"
                      style="margin: 0; padding: 0;"
                      :indeterminate="progresslogin"
                      value="100"
                    ></v-progress-linear>
                  </v-col>
                  <template v-if="!multipleAccess">
                    <v-card-text style="padding-bottom: 0; padding-top: 16px;">
                      <v-form ref="form" v-model="validate" lazy-validation>
                        <v-col lg="12" md="12" sm="12" style="padding: 5px;">
                          <v-text-field
                            name="username"
                            id="userInput"
                            required
                            clearable
                            v-model="user"
                            :rules="emailRules"
                            v-on:keyup="login"
                            type="text"
                            v-on:click="clear()"
                            autocomplete
                            :label="$t('user')"
                            outlined
                            :color="colorTheme"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="12" md="12" sm="12" style="padding: 5px;">
                          <v-text-field
                            name="password"
                            id="passInput"
                            required
                            clearable
                            v-model="password"
                            :rules="tokenRules"
                            v-on:keyup="login"
                            type="password"
                            v-on:click="clear()"
                            autocomplete
                            :label="$t('pass')"
                            outlined
                            :color="colorTheme"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="12" md="12" sm="12" style="padding-top: 0;">
                          <v-checkbox
                            v-model="remember"
                            :color="colorTheme"
                            style="margin-top: 0; padding: 0; height: 32px;"
                          >
                            <template v-slot:label>
                              <div class="regularText">{{ $t("rememberme") }}</div>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-form>
                    </v-card-text>
                    <v-card-actions style="margin-bottom: 0%;width: 100%;">
                      <v-col sm="12" md="12" lg="12" style="padding: 0px !important;">
                        <v-btn
                        class="regularText"
                          :color="colorTheme"
                          v-on:click="getLogin()"
                          dark
                          style=" width: 94%; height: 55px;"
                        >{{ loginBtn }}</v-btn>
                      </v-col>
                    </v-card-actions>
                    <v-row></v-row>
                    <v-col
                      sm="12"
                      md="12"
                      lg="12"
                      cols="12"
                      style="padding: 0px !important; margin-top:1%;"
                    >
                      <v-icon
                        :color="colorTheme"
                        v-if="this.$store.state.worldVisible == true"
                      >mdi-earth</v-icon>
                    </v-col>
                    <v-col sm="12" md="12" lg="12" cols="12" style="padding: 0px !important;">
                      <p
                        class="regularText"
                        v-on:click="changeLocale('es')"
                        :style="hoveres"
                        v-on:mouseover="mouseover('es')"
                        v-on:mouseleave="mouseleave('es')"
                      >ES &nbsp;</p>
                      <p>|</p>
                      <p
                        class="regularText"
                        v-on:click="changeLocale('en')"
                        :style="hoveren"
                        v-on:mouseover="mouseover('en')"
                        v-on:mouseleave="mouseleave('en')"
                      >&nbsp; EN</p>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-row justify="space-around" style="display: contents;">
                      <v-col sm="12" md="12" lg="12" class="pa-1">
                        <v-list
                          shaped
                          subheader
                          class="elevation-1"
                          max-height="67%"
                          :style="styleListOfAccess"
                        >
                          <v-subheader class="subtitle3Text">{{ $t("subheader") }}</v-subheader>
                          <v-list-item-group v-model="selectedVal" max="1">
                            <template v-for="item in multipleUserData">
                              <v-divider :key="item.AccessId"></v-divider>
                              <v-list-item :key="item.AccessId" :value="item">
                                <template v-slot:default="{ active, toggle }">
                                  <v-list-item-action>
                                    <v-checkbox
                                      :color="colorTheme"
                                      :input-value="active"
                                    ></v-checkbox>
                                  </v-list-item-action>

                                  <v-list-item-content style="text-align: left;">
                                    <v-list-item-title class="regularText">
                                      {{ item.DealerName }} ({{item.Level}}  - {{ item.State }})
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="regularText">
                                      {{ item.ClientName }}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                            </template>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                    <v-row justify="space-around" class="ma-1">
                      <v-card-actions style="margin-bottom: 0; padding-top: 0; padding-bottom: 0;">
                        <v-col lg="12" sm="12" md="12" style=" padding-top: 0; padding-bottom: 0;">
                          <v-btn
                            color="#AAAAAA"
                            v-on:click="cancel()"
                            class="regularText white--text mr-3"
                          >{{ $t("cancel").toUpperCase() }}</v-btn>
                          <v-btn
                            :color="colorTheme"
                            v-on:click="selectedAccess()"
                            class="regularText white--text"
                          >{{ $t("selectUser").toUpperCase() }}</v-btn>
                        </v-col>
                      </v-card-actions>
                    </v-row>
                  </template>
                </v-card-title>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
        <template></template>
      </v-container>
      <v-footer ref="footer" absolute style="position: sticky;bottom: 0% !important;">
        <v-col class="text-center" style="padding-top:0;padding-bottom: 4px;">
          <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-4"
            :color="colorTheme"
            icon
            v-on:click="redirectToWebSiteBoson(icon)"
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center footerText" cols="12" style="padding-top:0;padding-bottom: 0;">
          &copy; {{ new Date().getFullYear() }} Boson TI SA de CV.
          {{ $t("rights") }}&nbsp;v2.1.0
        </v-col>
      </v-footer>
    </v-app>
    <v-dialog v-model="invalidUser" persistent width="300">
      <v-card color="grey darken-1" dark>
        <v-card-title></v-card-title>
        <v-card-text>{{ $t("invalidUser") }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text v-on:click="InvalidUser()">
            {{
            $t("accept").toUpperCase()
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "login",
  data: () => ({
    page: 1,
    pageCount: 0,
    hoveres: "",
    hoveren: "",
    worldVisible: false,
    icons: ["mdi-earth", "mdi-facebook", "mdi-linkedin"],
    //checkbox: false
  }),
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.dispatch("GetAllRememberUserDB");
    this.$store.commit("loginBtn", this.$i18n.t("loginCard"));
  },
  mounted() {
    if (!this.$vuetify.theme.dark) {
      if (i18n.locale == "es") {
        this.hoveres = "color: " + this.$store.state.colorTheme;
        this.hoveren = "color: black";
      } else {
        this.hoveres = "color: black";
        this.hoveren = "color: " + this.$store.state.colorTheme;
      }
    } else {
      if (i18n.locale == "es") {
        this.hoveres = "color: " + this.$store.state.colorTheme;
        this.hoveren = "color: white";
      } else {
        this.hoveres = "color: white";
        this.hoveren = "color: " + this.$store.state.colorTheme;
      }
    }
  },
  computed: {
    ...mapState([
      "setLocale",
      "emailRules",
      "tokenRules",
      "headers",
      "multipleUserData",
      "multipleAccess",
      "search",
      "invalidUser",
      "colorTheme",
      "loginBtn",
      "styleLogo",
      "styleMargin",
      "styleListOfAccess"
    ]),

    user: {
      get: function() {
        return this.$store.state.username;
      },
      set: function(value) {
        this.$store.commit("userEntry", value);
      }
    },
    password: {
      get: function() {
        return this.$store.state.password;
      },
      set: function(value) {
        this.$store.commit("passEntry", value);
      }
    },
    validate: {
      get: function() {
        return this.$store.state.valid;
      },
      set: function(value) {}
    },
    selectedVal: {
      get: function() {
        return this.$store.state.selectedVal;
      },
      set: function(value) {
        this.$store.commit("selectedAccessValue", value);
      }
    },
    remember: {
      get: function() {
        return this.$store.state.remember;
      },
      set: function(value) {
        this.$store.commit("rememberMe", value);
      }
    },
    progresslogin: {
      get: function() {
        return this.$store.state.progresslogin;
      },
      set: function() {}
    }
  },
  methods: {
    redirectToWebSiteBoson(linkTo) {
      if (linkTo == "mdi-earth") {
        window.open("https://www.bosonti.com/", "_blank");
      } else if (linkTo == "mdi-facebook") {
        window.open("https://www.facebook.com/bosonti", "_blank");
      } else if (linkTo == "mdi-linkedin") {
        window.open("https://www.linkedin.com/company/bosonti/", "_blank");
      }
    },
    mouseover: function(val) {
      if (val == "es") this.hoveres = "color: " + this.$store.state.colorTheme;
      else this.hoveren = "color: " + this.$store.state.colorTheme;
    },
    mouseleave: function(val) {
      if (val == "es") {
        if (!this.$vuetify.theme.dark) {
          if (i18n.locale == "es") {
            this.hoveres = "color: " + this.$store.state.colorTheme;
          } else {
            this.hoveres = "color: black";
          }
        } else {
          if (i18n.locale == "es") {
            this.hoveres = "color: " + this.$store.state.colorTheme;
          } else {
            this.hoveres = "color: white";
          }
        }
      } else {
        if (!this.$vuetify.theme.dark) {
          if (i18n.locale == "en") {
            this.hoveren = "color: " + this.$store.state.colorTheme;
          } else {
            this.hoveren = "color: black";
          }
        } else {
          if (i18n.locale == "en") {
            this.hoveren = "color: " + this.$store.state.colorTheme;
          } else {
            this.hoveren = "color: white";
          }
        }
      }
    },
    changeLocale(locale) {
      localStorage.language = locale.trim();
      i18n.locale = locale;
      if (!this.$vuetify.theme.dark) {
        if (i18n.locale == "es") {
          this.hoveres = "color: " + this.$store.state.colorTheme;
          this.hoveren = "color: black";
        } else {
          this.hoveres = "color: black";
          this.hoveren = "color: " + this.$store.state.colorTheme;
        }
      } else {
        if (i18n.locale == "es") {
          this.hoveres = "color: " + this.$store.state.colorTheme;
          this.hoveren = "color: white";
        } else {
          this.hoveres = "color: white";
          this.hoveren = "color: " + this.$store.state.colorTheme;
        }
      }
      this.$refs.form.resetValidation();
      this.$store.commit("setValuesLanguage");
      this.$store.commit("loginBtn", i18n.t("loginCard"));
    },
    login: function(event) {
      if (event.keyCode === 13) {
        this.getLogin();
      }
    },
    clear() {
      this.$refs.form.resetValidation();
    },
    getLogin() {
      var offline = JSON.parse(localStorage.getItem("offline"));
      if (this.$store.state.loginBtn == this.$i18n.t("cancel")) {
        if (offline == false) {
          this.$store.dispatch("cancelLogin");
        }

        this.$store.commit("loginBtn", i18n.t("loginCard"));
        this.$store.commit("progresslogin", false);
      } else {
        if (
          this.$store.state.username != "" &&
          this.$store.state.password != ""
        ) {
          this.$store.commit("loginBtn", this.$i18n.t("cancel"));
          this.$store.commit("progresslogin", true);
          if (offline == true) {
            this.$store.commit("loginOffline", true);
            this.$store.dispatch("LastUserLogin");
          } else {
            this.$store.dispatch("getLogin");
          }
        } else if (this.$store.state.username == "") {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: this.$t("invalidEmail")
          });
        } else if (this.$store.state.password == "") {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: this.$t("invalidPass")
          });
        }
      }
    },
    cancel() {
      this.$store.commit("progresslogin", false);
      this.$store.commit("cancelMultipleAccess");
    },
    selectedAccess() {
      if (this.$store.state.selectedVal != undefined) {
        this.$store.commit("progresslogin", true);
        this.$store.commit(
          "selectedAccessEntry",
          this.$store.state.selectedVal
        );
        this.$store.dispatch("getToken", this.$store.state.SelectedAccess);
      }
    },
    InvalidUser() {
      this.$store.commit("progresslogin", false);
      this.$store.commit("invalidUser", false);
    }
  }
};
</script>

<style>
#logg div.v-application--wrap {
  min-height: 100vh !important;
}
.login {
  background-image: url("../assets/waves-ligth.png");
  height: 100%;
  width: 100%;
  position: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loginDark {
  background-image: url("../assets/waves-dark.png");
  height: 100%;
  width: 100%;
  position: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color:#121212;
}
body,
html {
  height: 100% !important;
  width: 100% !important;
  margin: 0;
  font: 400 15px/1.8 Arial;
  color: #777;
  min-height: 100% !important;
}

#inspire {
  background: none;
}

p {
  display: inline-block;
  cursor: pointer;
}

.primary--text {
  color: #8fae2d !important;
}

.theme--light.v-text-field--outline .v-input__slot {
  border: 1.5px solid rgba(0, 0, 0, 0.2);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

.logoBti {
  margin: 0;
  width: 450px;
}

.cardLogin {
  border-radius: 1.5rem !important;
  padding: 5px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 2px 10px 0 rgba(0, 0, 0, 0.12) !important;
  height: 90%;
  width: 450px;
  max-height: 520px;
  min-height: 470px;
  max-width: 97% !important;
}

.form-radio {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  position: relative;
  background-color: #f1f1f1;
  color: #8fae2d;
  top: 10px;
  height: 20px;
  width: 20px;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  margin-right: 7px;
  outline: none;
  border: 2px solid #8ba931;
}
.form-radio:checked::before {
  position: absolute;
  font: 13px/1 Arial;
  left: 4px;
  top: 1px;
  content: "\02143";
  transform: rotate(40deg);
}
.form-radio:hover {
  background-color: #f7f7f7;
}
.form-radio:checked {
  background-color: #f1f1f1;
}
label {
  font: 15px/1.7 Arial;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
}
.paddingLoginCard {
  padding: 2%;
}
@media only screen and (min-width: 500px) and (max-height: 773px) {
  .paddingLoginCard {
    padding: 0%;
  }
}
</style>
